import { useTranslation } from "react-i18next"
import { useState } from "react"
import { Switch } from "../../../components/ui/Switch"
import toast from "react-hot-toast"

const Counter = ({ count, setCount, max = 24 }) => {
  return (
    <>
      <button
        type="button"
        onClick={() => setCount((c) => c - 1)}
        disabled={count === 1}
        className="btn btn-primary m-3 btn-sm"
      >
        -
      </button>
      {count}
      <button
        type="button"
        onClick={() => setCount((c) => c + 1)}
        disabled={count === max}
        className="btn btn-primary m-3 btn-sm"
      >
        +
      </button>
    </>
  )
}

const ColumnPicker = ({ data, cols, setCols }) => {
  const toggle = (c) =>
    setCols((currents) => {
      const cpy = [...currents]
      return cpy.includes(c) ? cpy.filter((x) => x !== c) : cpy.concat(c)
    })
  return (
    <>
      <div className="d-flex flex-row justify-content-center align-items-start">
        <div className="d-flex flex-column justify-content-center align-items-start">
          {data.map((c, ix) => (
            <div key={ix} className="d-flex align-items-center mb-1">
              <Switch setStatus={() => toggle(c)} status={cols.includes(c)} />
              <span className="ms-3">{c}</span>
            </div>
          ))}
        </div>
      </div>

      {/* <table>
            <tbody>
                {data.map((c,ix) =>
                    <tr key={ix}>
                        <td>
                            <Switch
                                setStatus={() => toggle(c)}
                                status={cols.includes(c)} />
                        </td>
                        <td>{c}</td>
                    </tr>
                )}
            </tbody>
        </table> */}
    </>
  )
}

export const Config = ({ status, myRoom, setStart }) => {
  const { t } = useTranslation()

  // computed
  const we = status.players.filter((p) => myRoom.players.includes(p.id))

  // state
  const [rounds, setRounds] = useState(3)
  const [cols, setCols] = useState([])

  // data
  const data = ["actors", "brands", "clubs", "colours", "countries", "films"]

  // methods
  const start = () => {
    {
      const ok = cols.length > 0
      if (!ok) {
        toast.error(t(`games.tutti.err_cols`))
        return
      }
    }
    {
      const ok = we.length > 1
      if (!ok) {
        toast.error(t(`games.tutti.err_players`))
        return
      }
    }

    toast.success(t(`games.tutti.new_game`))
    setStart(cols, rounds)
  }

  return (
    <>
      <div className="title pt-4">{t(`games.tutti.configuring`)}</div>
      <div id="category-container" className="container-sm container-mini">
        <div className="d-flex flex-row flex-wrap justify-content-center">
          {/* usuarios online */}
          <div className="col-lg-4 col-12">
            <h6>{t("games.tutti.online", { count: we.length })}</h6>
            {we.map((u, uix) => (
              <div key={uix} className="row">
                &bull;&nbsp;{u.nick}
              </div>
            ))}
          </div>

          {/* config */}
          <div className="col-lg-8 col-12">
            <center>
              <h4>{t(`games.tutti.columns`)}</h4>
              <ColumnPicker data={data} cols={cols} setCols={setCols} />
              <hr />
              <h4>{t(`games.tutti.rounds`)}</h4>
              <Counter count={rounds} setCount={setRounds} />
              <br />
              <button
                type="button"
                onClick={start}
                className="btn btn-primary m-3"
              >
                {t(`games.tutti.start`)}
              </button>
            </center>
          </div>
        </div>
      </div>
    </>
  )
}
